// A fresh random uuid for a chart or a control the canvas is creating.
//
// Only for LOCALLY minted ids. Server-derived ids (a source's `dataset_uuid`,
// an annotation's chart id) come from the server (`BiSourceSummary.datasetUuid`,
// the query response). Never recompute them here: a second copy of an identity
// rule can drift, and every built chart then resolves a dataset that does not
// exist. Nothing derives security from this id's entropy: the server uses a
// client id only as a map key inside the caller's own document.

const HEX = "0123456789abcdef";

function formatUuid(bytes: Uint8Array): string {
  let s = "";
  for (let i = 0; i < 16; i += 1) {
    const b = bytes[i] as number;
    s += HEX[b >> 4];
    s += HEX[b & 0x0f];
    if (i === 3 || i === 5 || i === 7 || i === 9) s += "-";
  }
  return s;
}

/** A version 4 uuid.
 *
 *  `crypto.randomUUID` where it exists (every browser this app supports, and
 *  Node 19+ under vitest); the fallback is only reached on an insecure origin
 *  in dev, where a v4-shaped id from `Math.random` is still a perfectly good
 *  local key. */
export function newUuid(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;
  return formatUuid(bytes);
}
